// extracted by mini-css-extract-plugin
export default {"subLabel":"InputLabel_subLabel__88uCh"};